export enum TaggingTool {
    Pan,
    Brush,
    Pen,
    Eraser,
    Select,
    Brightness,
    Contrast,
    BackgroundCut,
    ForegroundCut,
    SmartFill,
    ZoomIn,
    ZoomOut,
    Addition,
    Subtraction,
    BoundingBox,
    PredictionsOverlay,
    RegionOfInterest,
    Grid
}



// WEBPACK FOOTER //
// ./src/providers/workspace/tagging-tool.enum.ts